import React, { useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import {
  builderDefaultOptionsSelector,
  builderSelectedOptionsSelector,
} from '../../../../../redux/selectors/builder';
import {
  setDateKindAction,
  setBuilderTimeWindowAction,
} from '../../../../../redux/slices/oldBuilder';
import {
  QueryType,
  DateKindKey,
} from '../../../../../utils/apollo/graphqlSchema';
import { assertCondition } from '../../../../../utils/types';
import BuilderEnumSelect from '../../../../../components/Builder/BuilderFields/BuilderEnumSelect';
import { batch } from 'react-redux';
import { dateKindTooltip } from '../../../../../components/KubitTooltip/globalTooltips';

const QueryDateKind = () => {
  const dispatch = useAppDispatch();

  const defaultOptions = useAppSelector((state) =>
    builderDefaultOptionsSelector(state),
  );
  const selectedOptions = useAppSelector((state) =>
    builderSelectedOptionsSelector(state),
  );

  assertCondition(
    defaultOptions?.type === QueryType.Expression &&
      selectedOptions?.type === QueryType.Expression,
  );

  const { dateKinds } = defaultOptions;
  const { dateKind, timeUnit } = selectedOptions;

  const handleChange = (dateKindKey: DateKindKey) => {
    batch(() => {
      dispatch(setDateKindAction({ dateKindKey }));
      dispatch(
        setBuilderTimeWindowAction({
          newValue: null,
        }),
      );
    });
  };

  const options = useMemo(() => {
    return dateKinds
      .filter(
        (dateKind) =>
          dateKind.supportedTimeUnits.includes(timeUnit) &&
          dateKind.key !== DateKindKey.Trigger,
      )
      .map((dateKind) => ({
        key: dateKind.key,
        name: dateKind.name,
        tooltip: dateKindTooltip(dateKind.key, dateKind.name),
      }));
  }, [dateKinds, timeUnit]);

  return (
    <BuilderEnumSelect
      label="Analyze data by"
      labelIsInSentence={true}
      enumOptions={options}
      selectedOption={dateKind}
      onChange={handleChange}
    />
  );
};

export default QueryDateKind;
